/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropInTopDrop
 */
export interface DropInTopDrop {
    /**
     * 
     * @type {string}
     * @memberof DropInTopDrop
     */
    dropId: string;
    /**
     * 
     * @type {string}
     * @memberof DropInTopDrop
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DropInTopDrop
     */
    slug: string;
    /**
     * 
     * @type {number}
     * @memberof DropInTopDrop
     */
    impressions: number;
    /**
     * 
     * @type {number}
     * @memberof DropInTopDrop
     */
    clicks: number;
    /**
     * 
     * @type {number}
     * @memberof DropInTopDrop
     */
    follows: number;
    /**
     * 
     * @type {number}
     * @memberof DropInTopDrop
     */
    uniqueUsers: number;
    /**
     * 
     * @type {number}
     * @memberof DropInTopDrop
     */
    ctr: number;
}

/**
 * Check if a given object implements the DropInTopDrop interface.
 */
export function instanceOfDropInTopDrop(value: object): value is DropInTopDrop {
    if (!('dropId' in value) || value['dropId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('impressions' in value) || value['impressions'] === undefined) return false;
    if (!('clicks' in value) || value['clicks'] === undefined) return false;
    if (!('follows' in value) || value['follows'] === undefined) return false;
    if (!('uniqueUsers' in value) || value['uniqueUsers'] === undefined) return false;
    if (!('ctr' in value) || value['ctr'] === undefined) return false;
    return true;
}

export function DropInTopDropFromJSON(json: any): DropInTopDrop {
    return DropInTopDropFromJSONTyped(json, false);
}

export function DropInTopDropFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropInTopDrop {
    if (json == null) {
        return json;
    }
    return {
        
        'dropId': json['dropId'],
        'name': json['name'],
        'slug': json['slug'],
        'impressions': json['impressions'],
        'clicks': json['clicks'],
        'follows': json['follows'],
        'uniqueUsers': json['uniqueUsers'],
        'ctr': json['ctr'],
    };
}

export function DropInTopDropToJSON(json: any): DropInTopDrop {
    return DropInTopDropToJSONTyped(json, false);
}

export function DropInTopDropToJSONTyped(value?: DropInTopDrop | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dropId': value['dropId'],
        'name': value['name'],
        'slug': value['slug'],
        'impressions': value['impressions'],
        'clicks': value['clicks'],
        'follows': value['follows'],
        'uniqueUsers': value['uniqueUsers'],
        'ctr': value['ctr'],
    };
}

